import subGroupingTemplate from './subGrouping.html'

/** @ngInject */
export function subGrouping() {
    return {
        restrict: 'E',
        scope: {
            subGroups: '=',
            parentController: '=',
            itemSel: '=',
            tableId: '@'
        },
        templateUrl: subGroupingTemplate,
        controller: SubGroupingTableController,
        controllerAs: 'subGroupingTableController'
    };
}

/** @ngInject */
export class SubGroupingTableController {
    constructor($scope, $rootScope) {
        this.$scope = $scope;
        this.$rootScope = $rootScope;

        if(this.$scope.itemSel.subGrouping && this.$scope.itemSel.subGrouping !== '') {
            this.$scope.itemSel.subGrouping = this.$scope.subGroups.filter(
                subGroup => subGroup.code === this.$scope.itemSel.subGrouping)[0].code;
            this.$scope.itemSel.tableId = this.$scope.tableId;
            this.$rootScope.$broadcast('group.change', this.$scope.itemSel);
        } else if(!this.$scope.itemSel.$hideTable){
            this.$scope.itemSel.$hideGroupTable = true;
        }
    }

    updateGrouping() {
        this.setGrouping();
    }

    setGrouping() {
        if(this.$scope.itemSel.subGrouping !== '') {
            this.$scope.itemSel.$hideGroupTable = false;
            this.$scope.itemSel.tableId = this.$scope.tableId;
            this.$rootScope.$broadcast('group.change', this.$scope.itemSel);
        }else {
            this.$scope.itemSel.$hideGroupTable = true;
            delete this.$scope.itemSel.subGrouping;
        }
        this.$scope.itemSel.$hideTable = false;
    }
}
